import React from "react";
import "../style/search.css";
import Loupe from "../loupe.svg";
import axios from "axios";
import { Link } from "react-router-dom";
import "../style/shop.css";

class Search extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      inputValue: "",
      data: [],
    };
    this.updateInputValue = this.updateInputValue.bind(this);
    this.submitFrom = this.submitFrom.bind(this);
  }

  updateInputValue(event) {
    this.setState({ inputValue: event.target.value });
  }
  submitFrom = (event) => {
    event.preventDefault();
    axios
      .get(`https://api.jikan.moe/v3/search/anime?q=${this.state.inputValue}`)
      .then((res) => {
        const data = res.data.results;
        this.setState({ data });
        this.setState({ showData: 2 });
      });
  };

  render() {
    return (
      <div>
        <div>
          <form onSubmit={this.submitFrom}>
            <img src={Loupe} alt="" />
            <input
              type="text"
              value={this.state.inputValue}
              onChange={this.updateInputValue}
              placeholder="Search for anime"
            />
          </form>
        </div>
        <div className="container py-5">
          <div className="row">
            {this.state.data.map((item) => (
              <div
                key={item.mal_id}
                className="col-lg-4 col-md-6 col-sm-12 d-flex justify-content-center"
              >
                <div className="hover hover-1 text-white rounded">
                  <img src={item.image_url} alt={item.title} />
                  <div className="hover-overlay"></div>
                  <div className="hover-1-content px-5 py-4">
                    <p className="hover-1-title text-uppercase font-weight-bold mb-0">
                      {" "}
                      {item.title}
                    </p>
                    <p className="hover-1-description font-weight-light mb-0">
                      {" "}
                      <button>
                        <Link
                          style={{ color: "#fff", textDecoration: "none" }}
                          to={`/shop/${item.mal_id}`}
                        >
                          More Info
                        </Link>{" "}
                      </button>
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  }
}

export default Search;
